import { render, staticRenderFns } from "./uf_federal_project_id.vue?vue&type=template&id=6edc42f4&scoped=true"
import script from "./uf_federal_project_id.vue?vue&type=script&lang=js"
export * from "./uf_federal_project_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edc42f4",
  null
  
)

export default component.exports